import { call, put, takeEvery } from 'redux-saga/effects'
import {
  // Doctor List
  getDoctorListApiData,
  getDoctorListApiSuccess,
  getDoctorListApiFailed,
  doctorStatusChangeApiData,
  doctorStatusChangeApiSuccess,
  doctorStatusChangeApiFailed,
  // doctor Details
  getDoctorDetailsApiData,
  getDoctorDetailsApiSuccess,
  getDoctorDetailsApiFailed,

  // Doctor Specification
  getDoctorSpecificationListApiData,
  getDoctorSpecificationListApiSuccess,
  getDoctorSpecificationListApiFailed,
  addDoctorSpecificationApiData,
  addDoctorSpecificationApiSuccess,
  addDoctorSpecificationApiFailed,
  updateDoctorSpecificationApiData,
  updateDoctorSpecificationApiSuccess,
  updateDoctorSpecificationApiFailed,
  doctorSpecificationStatusChangeApiData,
  doctorSpecificationStatusChangeApiSuccess,
  doctorSpecificationStatusChangeApiFailed,
} from './slice'

import { API } from '../../services'

// ---------------- Doctor List ----------------
function* getDoctorListApi({ payload }) {
  try {
    const response = yield call(API.healthcareManagement.getDoctorList, payload)
    if (response.data && response.status === 200) {
      yield put(getDoctorListApiSuccess(response.data))
    } else {
      yield put(getDoctorListApiFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(getDoctorListApiFailed({ message: error.message }))
  }
}

function* doctorStatusChangeApi({ payload }) {
  try {
    const response = yield call(API.healthcareManagement.doctorStatusChange, payload)
    if (response.data && response.status === 200) {
      yield put(doctorStatusChangeApiSuccess(response.data))
    } else {
      yield put(doctorStatusChangeApiFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(doctorStatusChangeApiFailed({ message: error.message }))
  }
}
// ---------------- Doctor Details ----------------
function* getDoctorDetailsApi({ payload }) {
  try {
    const response = yield call(API.healthcareManagement.getDoctorDetails, payload)
    if (response.data && response.status === 200) {
      yield put(getDoctorDetailsApiSuccess(response.data))
    } else {
      yield put(getDoctorDetailsApiFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(getDoctorDetailsApiFailed({ message: error.message }))
  }
}

// ---------------- Doctor Specification ----------------
function* getDoctorSpecificationListApi({ payload }) {
  try {
    const response = yield call(API.healthcareManagement.getDoctorSpecificationList, payload)
    if (response.data && response.status === 200) {
      yield put(getDoctorSpecificationListApiSuccess(response.data))
    } else {
      yield put(getDoctorSpecificationListApiFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(getDoctorSpecificationListApiFailed({ message: error.message }))
  }
}

function* addDoctorSpecificationApi({ payload }) {
  try {
    const response = yield call(API.healthcareManagement.addDoctorSpecification, payload)
    if (response.data && response.status === 200) {
      yield put(addDoctorSpecificationApiSuccess(response.data))
    } else {
      yield put(addDoctorSpecificationApiFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(addDoctorSpecificationApiFailed({ message: error.message }))
  }
}

function* updateDoctorSpecificationApi({ payload }) {
  try {
    const response = yield call(API.healthcareManagement.updateDoctorSpecification, payload)
    if (response.data && response.status === 200) {
      yield put(updateDoctorSpecificationApiSuccess(response.data))
    } else {
      yield put(updateDoctorSpecificationApiFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(updateDoctorSpecificationApiFailed({ message: error.message }))
  }
}

function* doctorSpecificationStatusChangeApi({ payload }) {
  try {
    const response = yield call(API.healthcareManagement.doctorSpecificationStatusChange, payload)
    if (response.data && response.status === 200) {
      yield put(doctorSpecificationStatusChangeApiSuccess(response.data))
    } else {
      yield put(doctorSpecificationStatusChangeApiFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(doctorSpecificationStatusChangeApiFailed({ message: error.message }))
  }
}

export default function* healthcareSaga() {
  // Doctor List
  yield takeEvery(getDoctorListApiData.type, getDoctorListApi)
  yield takeEvery(doctorStatusChangeApiData.type, doctorStatusChangeApi)
  yield takeEvery(getDoctorDetailsApiData.type, getDoctorDetailsApi)
  // Doctor Specification
  yield takeEvery(getDoctorSpecificationListApiData.type, getDoctorSpecificationListApi)
  yield takeEvery(addDoctorSpecificationApiData.type, addDoctorSpecificationApi)
  yield takeEvery(updateDoctorSpecificationApiData.type, updateDoctorSpecificationApi)
  yield takeEvery(doctorSpecificationStatusChangeApiData.type, doctorSpecificationStatusChangeApi)
}
